import { useEffect, useRef, useState } from "react";
import { subscribeDialog } from "../lib/dialog";

export default function DialogHost() {
  const [dialog, setDialog] = useState(null);
  const confirmRef = useRef(null);

  useEffect(() => subscribeDialog(setDialog), []);

  useEffect(() => {
    if (!dialog) return undefined;
    confirmRef.current?.focus();
    const onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      e.stopPropagation();
      dialog.resolve(dialog.kind === "confirm" ? false : undefined);
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [dialog]);

  if (!dialog) return null;

  const close = (confirmed) => dialog.resolve(dialog.kind === "confirm" ? confirmed : undefined);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={dialog.title || "Dialog"}
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm [font-family:'DM_Sans',sans-serif]"
      onMouseDown={(e) => { if (e.target === e.currentTarget) close(false); }}
    >
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
        {dialog.title && (
          <h2 className="mb-2 text-base font-semibold text-gray-900">{dialog.title}</h2>
        )}
        {dialog.message && (
          <p className="whitespace-pre-line text-sm leading-relaxed text-gray-600">{dialog.message}</p>
        )}
        <div className="mt-6 flex justify-end gap-2">
          {dialog.kind === "confirm" && (
            <button
              type="button"
              onClick={() => close(false)}
              className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-50"
            >
              {dialog.cancelLabel}
            </button>
          )}
          <button
            ref={confirmRef}
            type="button"
            onClick={() => close(true)}
            className={`rounded-lg border-none px-4 py-2 text-sm font-semibold text-white cursor-pointer ${dialog.danger ? "bg-red-600 hover:bg-red-700" : "bg-[#4DB8B5] hover:bg-[#3DA8A5]"}`}
          >
            {dialog.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
